import React, { Component} from 'react';
import PropTypes from 'prop-types';
import { semanticColors } from '../Globals/styles';
var Radium = require('radium');

class SuggestInput extends Component {
  constructor(props) {
    super(props);
    this.state ={
      hideSuggestions: true,
      selected: {id: null, name: null},
      firstMount: true
    };
  }
  componentWillReceiveProps = (nextProps) => {
    if(nextProps.initialValue)
      if(!this.state.selected.name && this.state.firstMount){
        this.refs.input.value = nextProps.initialValue.name
        this.setState({
          selected: nextProps.initialValue,
          firstMount: false
        })
      }
  };
  componentDidMount = () => {
    if (this.props.defaultValue){
      this.setState({
        selected: this.props.defaultValue
      })
      this.refs.input.value = this.props.defaultValue.name
      this.props.onChange(this.props.defaultValue);
    }
    else if(this.props.value){
      this.setState({
        selected: this.props.value
      })
      this.refs.input.value = this.props.value.name
      this.props.onChange(this.props.value);
    }
  };
  onBlur = () => {
    //if it has suggestions check if first suggestion starts with value of inputfield
    if(this.props.suggestions[0] && this.refs.input.value.length > 1){
      if (this.props.suggestions[0].name.replace(/^\s+|\s+$/g, "").toLowerCase().startsWith(this.refs.input.value.replace(/^\s+|\s+$/g, "").toLowerCase()))
        this.onItemSelected(this.props.suggestions[0]);
    }
    this.setState({hideSuggestions: true});
    if(this.props.onBlur) this.props.onBlur();
  };
  onInputChange = (evt) => {
    var selected = {id: null, name: evt.target.value};
    this.props.onQuery(selected.name)
    this.setState({hideSuggestions: false, selected: selected});
    this.props.onChange(selected);
  };
  onItemSelected = (suggestion) => {
    this.setState({hideSuggestions: true, selected: suggestion});
    this.refs.input.value = suggestion.name
    this.props.onChange(suggestion);
  };
  shouldCompRenderSuggestions = () => {
    return (this.props.suggestions.length < 1 ||
            this.state.hideSuggestions)
  };
  renderSuggestions = () => {
    if (this.shouldCompRenderSuggestions()) return null;
    var that = this;
    var sugNodes = this.props.suggestions.map(s => {
      return that.renderSuggestionItem(s);
    });
    return  <div style={styles.container}>
              <ul
                style={[styles.listGroup, this.props.styleUl && this.props.styleUl]}
                className="list-group"
                ref="ul">
                {sugNodes}
              </ul>
          </div>
  };
  renderSuggestionItem = (suggestion) => {
    return <li
            style={styles.listGroupItem}
            onMouseDown={() => {
              this.onItemSelected(suggestion)
            }}
            onClick={() => {
              this.onItemSelected(suggestion)
            }}
            onTouchStart={() =>{
              this.onItemSelected(suggestion)
            }}
            key={suggestion.id}>
            {suggestion.name}
          </li>
  };
  renderInput = () => {
    var defProps = {
      className: "form-control",
      ref: "input",
      onBlur: this.onBlur,
      onChange: this.onInputChange,
      placeholder: this.props.placeholder,
      style: this.props.styleInput ? this.props.styleInput : {  border: 'none',
    boxShadow: '0 1px 2px rgba(0,0,0,0.2) inset, 0 -1px 0 rgba(0,0,0,0.05) inset',
    borderRadius: '2px'}
    }
    return this.props.type==="textArea" ?
      <textArea {...defProps}/> : <input {...defProps}/>
  };
  render() {
    return (
      <div>
        {this.renderInput()}
        {this.renderSuggestions()}
      </div>
    );
  }
}

var styles = {
  container: {
    width: '100%',
    paddingRight: '24px',
    position: 'absolute',
    zIndex: '10'
  },
  listGroup: {
    borderRadius: '2px',
    width: '100%',
    boxShadow: '0 3px 8px #ddd',
    backgroundColor: '#fff'
  },
  listGroupItem: {
    cursor: 'pointer',
    padding: '5px 30px 5px 15px',
    border: 'none',
    display: 'block',
    clear: 'both',
    fontWeight: 'normal',
    lineHeight:  '1.4em',
    color: '#333333',
    wordWrap: 'break-word',
    textAlign: 'left',
    ':hover': {
      backgroundColor: semanticColors.infoLighter
    }
  }
}

  SuggestInput.propTypes = {
    onChange: PropTypes.func.isRequired,
    onQuery: PropTypes.func.isRequired,
    suggestions: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string
		})).isRequired,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    styleUl: PropTypes.object,
    onBlur: PropTypes.func,
    value: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string
    })
  };
  SuggestInput.defaultProps = {
    type: "text",
    placeholder: null
  };

export default Radium(SuggestInput);


// WEBPACK FOOTER //
// ./src/App/Common/suggestInput.jsx